/**
 * @voltxampere/ui — DIP-40 breakout variant (Sprint 47.5-2, placeholder)
 *
 * PLACEHOLDER. DIP-40 to breadboard adapter for ATmega2560 /
 * ATmega1284 chips. Sprint 47.5 MVP renders as mcu-execution with
 * atmega2560 family defaults.
 *
 * Reference: Generic 40-pin DIP breakout PCB. Used for ATmega2560
 * (Arduino Mega chip) bare-chip prototyping.
 *
 * Engine zero-diff invariant honored — canonical `mcu-execution`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuBreakoutDip40 = {
    id: "breakout-dip40",
    nameTr: "DIP-40 Breakout (ATmega2560/1284 bare chip, placeholder)",
    nameEn: "DIP-40 Breakout (ATmega2560/1284 bare chip, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "DIP-40",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "atmega2560",
        clockHz: 16e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 5,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-breakout-dip40.js.map